export enum VehicleEventType {
    Distance,
    TotalFuel,
}

export interface VehicleEventInfo {
    carId: string;
    vehicleId: string;
    type: VehicleEventType;
    value: number;
    timestamp: string;
    customerId: string;
    employeeId: string;
    costCenterId: string;
}

export interface VehicleEventQueryParams {
    vehicleIds: string[];
    windowStartTime: string;
    windowEndTime: string;
    groupByWorkShiftTimeslots : boolean;
}
